import React from "react";
import { Button } from "./button";
import { ArrowLeft, Plus } from "lucide-react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

/**
 * Basic page header component for management pages like ProjectManagementPage
 * Features: title, subtitle, and action buttons area
 */
export function PageHeader({ title, subtitle, children }: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6 mt-4">
      <div>
        <h1 className="text-3xl font-semibold">{title}</h1>
        {subtitle && (
          <p className="text-bits-grey-600 text-md mt-1">{subtitle}</p>
        )}
      </div>

      {children && (
        <div className="flex items-center gap-3">
          {children}
        </div>
      )}
    </div>
  );
}

interface ProjectHeaderProps {
  title: string;
  subtitle?: string;
  onBackClick: () => void;
  children?: React.ReactNode;
}

/**
 * Project details header component with back button navigation
 * Features: back button, title, subtitle, and action buttons area
 */
export function ProjectHeader({ title, subtitle, onBackClick, children }: ProjectHeaderProps) {
  return (
    <div className="flex flex-row items-start gap-3 mb-6 mt-4">
      <div className="flex items-center">
        <button
          onClick={onBackClick}
          className="p-2 rounded-full hover:bg-gray-100"
        >
          <ArrowLeft className="h-6 w-6 text-gray-700" />
        </button>
      </div>

      <div className="flex flex-col flex-grow">
        <h1 className="text-3xl font-semibold">{title}</h1>
        {subtitle && (
          <p className="text-bits-grey-600 text-md mt-1">{subtitle}</p>
        )}
      </div>

      {children && (
        <div className="flex items-center gap-3">
          {children}
        </div>
      )}
    </div>
  );
}